// extracted by mini-css-extract-plugin
export default {"container":"AvailabilityError-module__container-R6tBPU","icon":"AvailabilityError-module__icon-tM8slP","red":"AvailabilityError-module__red-u2_yaW"};